<template>
  <div>
    <Header>
      Grafiki
      <template v-if="user.can_manage_schedules" #right>
        <b-button variant="primary" size="sm" @click="$inertia.visit(route('schedules.create'))">
          <b-icon icon="plus"/>
        </b-button>
      </template>
    </Header>

    <b-table-simple :responsive="true" borderless :small="isMobile" class="table-vcenter">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Fryzjer</b-th>
          <b-th>Data</b-th>
          <b-th>Dzień</b-th>
          <b-th class="text-center">
            <b-icon icon="info-circle"/>
          </b-th>
          <b-th class="text-right">#</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="schedule in schedules">
          <b-tr :key="`header_${schedule.id}`">
            <b-td colspan="5" style="padding-bottom: 0; padding-top: 1rem">
              <b-progress :max="schedule.max_reservations" height="2px">
                <b-progress-bar :value="getProgressValue(schedule.barber, schedule, 'active')" variant="success"/>
                <b-progress-bar :value="getProgressValue(schedule.barber, schedule, 'diff')" variant="transparent"/>
                <b-progress-bar :value="getProgressValue(schedule.barber, schedule, 'blocked')" variant="danger"/>
              </b-progress>
            </b-td>
          </b-tr>
          <b-tr :key="schedule.id" class="bg-light">
            <b-td nowrap>{{ schedule.barber.name }}</b-td>
            <b-td nowrap>
              <div>
                {{ formatDateShort(schedule.date_string) }}
              </div>
              <div>
                {{ schedule.start_hour }} -
                {{ schedule.end_hour }}
              </div>
            </b-td>
            <b-td nowrap>
              <span v-if="schedule.is_today" class="text-success">
                Dziś
              </span>
              <span v-else>{{ schedule.day_string }}</span>
            </b-td>
            <b-td class="text-center" nowrap>
            <span class="p-2" @click="showSetOnline(schedule)">
              <b-icon v-if="schedule.is_online" icon="globe2" class="text-primary"/>
              <b-icon v-else icon="telephone-fill" class="text-warning"/>
              <b-icon v-if="!schedule.is_visible" icon="eye-slash-fill" class="text-danger"/>
              <b-icon v-if="schedule.is_b2b" icon="file-earmark-text" class="text-warning"/>
            </span>
            </b-td>
            <b-td class="text-right" nowrap>
              <inertia-link
                v-if="user.can_manage_schedules"
                :href="route('schedules.edit', schedule.id)"
                as="b-button"
                variant="outline-primary"
                size="sm"
              >
                <b-icon icon="pencil-fill"/>
              </inertia-link>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>

    <SetOnlineModal
      ref="SetOnlineModal"
    />
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import SetOnlineModal from '@/Components/Schedule/SetOnlineModal'
import DateFormat from '@/Mixins/DateFormat'

export default {
  layout: Layout,
  mixins: [DateFormat],
  components: {
    Header,
    SetOnlineModal,
  },
  props: {
    schedules: Array,
    all_reservations_count: Array,
    all_active_reservations_count: Array,
    all_blocked_reservations_count: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        isOnline: false,
      }),
    }
  },
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  methods: {
    showSetOnline(schedule) {
      this.$refs.SetOnlineModal.show(schedule)
    },
    getProgressValue(barber, schedule, type) {
      const reservations_count = this.all_reservations_count[`${barber.id}#${schedule.date_string}`] ?? 0
      const active_reservations_count = this.all_active_reservations_count[`${barber.id}#${schedule.date_string}`] ?? 0
      const blocked_reservations_count = this.all_blocked_reservations_count[`${barber.id}#${schedule.date_string}`] ?? 0

      if (reservations_count <= 0) {
        return 0
      }

      switch (type) {
        case 'active':
          return active_reservations_count
        case 'blocked':
          return blocked_reservations_count
        case 'diff':
          return schedule.max_reservations - reservations_count
      }
    },
  },
}
</script>
